<mat-form-field appearance="outline">
  <mat-select
    [ngModel]="value"
    (ngModelChange)="onModelChanged($event)"
    [disabled]="disable"
    [placeholder]="placeholder"
    [panelClass]="panelClass"
  >
    <mat-select-trigger *ngIf="optionTemplate && fullObject">
      <ng-template [ngTemplateOutlet]="optionTemplate" [ngTemplateOutletContext]="{ item: fullObject }"></ng-template>
    </mat-select-trigger>

    <mat-option *ngFor="let item of items; let i = index" [id]="name + '-' + i" [value]="item[bindValue]">
      <ng-container *ngIf="!optionTemplate; else customTemplate">
        {{ item[bindLabel] }}
      </ng-container>
      <ng-template
        #customTemplate
        [ngTemplateOutlet]="optionTemplate"
        [ngTemplateOutletContext]="{ item: item }"
      ></ng-template>
    </mat-option>
  </mat-select>
</mat-form-field>
